import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import { Grid,LinearProgress } from "@mui/material";
import axios from "../../Uri";
import "react-toastify/dist/ReactToastify.css";
import ArchivedGuestPopUp from "./ArchivedGuestPopUp";
import { getArchivedGuests } from "../../redux/actions/GuestActions";
import { useDispatch, useSelector } from "react-redux";
function ArchivedGuest() {
  const data = useSelector((state) => state.GuestInfo.archievedGuests);
  console.log(data);
  let [pageNumber, setPageNumber] = useState(0);
  const [loader, setLoader] = useState(true);
  const columns = [
    {
      title: "Guest Name",
      field: "firstName",
      type: "text",
      headerStyle: {
        backgroundColor: "#1E90FF",
        color: "white",
      },
    },
    {
      title: "Building Name",
      field: "buildingName",
      type: "text",
      headerStyle: {
        backgroundColor: "#1E90FF",
        color: "white",
      },
    },
    {
      title: "Guest ID",
      field: "id",
      type: "text",
      headerStyle: {
        backgroundColor: "#1E90FF",
        color: "white",
      },
    },
    {
      title: "Phone Number",
      field: "personalNumber",
      headerStyle: {
        backgroundColor: "#1E90FF",
        color: "white",
      },
    },
    {
      title: "Check Out Date",
      field: "checkOutDate",
      headerStyle: {
        backgroundColor: "#1E90FF",
        color: "white",
      },
    },
    {
      title: "Bed ID",
      field: "bedId",
      headerStyle: {
        backgroundColor: "#1E90FF",
        color: "white",
      },
    },
  ];
  const dispatch = useDispatch();
  useEffect(() => {
    fetchData(pageNumber);
  }, []);
  const fetchData = (pageNumber) => {
    dispatch(getArchivedGuests(pageNumber));
  };
  const [open, setOpen] = React.useState(false);
  const handleCloseGuestModalWindow = () => setOpen(false);
  const [GuestDetails, setGuestDetails] = React.useState({});
  const loadMoreHandle = (i) => {
    let bottom =
      i.target.scrollHeight - i.target.clientHeight - i.target.scrollTop < 10;
    if (bottom) {
      let page_ = pageNumber + 1;
      fetchData(page_);
      setLoader(true);
      setPageNumber(page_);
    }
  };
  return (
    <>
      <ArchivedGuestPopUp
        open={open}
        handleCloseGuestModalWindow={handleCloseGuestModalWindow}
        GuestDetails={GuestDetails}
      />
      <Grid container>
        <Grid xs={12}>
          <div
            onScroll={loadMoreHandle}
            class="container"
            style={{ overflowY: "auto", height: "800px", border: "none" }}
          >
            <MaterialTable
              title="Vacated Guests From All Buildings"
              data={data}
              sx={{ color: "white" }}
              columns={columns}
              onRowClick={async (event, rowData) => {
                await axios
                  .get(`/guest/getGuestByGuestId/${rowData.id}`)
                  .then((res) => {
                    setGuestDetails(res.data);
                    setOpen(true);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }}
              options={{
                exportButton: true,
                pageSize: 20,
                actionsColumnIndex: -1,
                paging: false,
                grouping: true,
                addRowPosition: "first",
                headerStyle: {
                  backgroundColor: "#1E90FF",
                  color: "white",
                  fontSize: "15px",
                },
                rowStyle: {
                  fontSize: 16,
                },
              }}
            />
            <br />
            <LinearProgress color="primary" />
            <h3 className="load">Loading 👱🏿‍♂️...</h3>
          </div>
        </Grid>
      </Grid>
    </>
  );
}
export default ArchivedGuest;
